import { __awaiter } from "tslib";
import { axiosClient } from '@as-react/common-utils';
import { isNullOrUndefined } from '@as-react/common-utils';
class DeliveryPromiseAPI {
    constructor() {
        this.getDeliveryPromise = (servicesEndpointUrl, skuId, productId, authenticationConfig) => {
            return new Promise((resolve, reject) => {
                const axiosConfig = {
                    url: `${servicesEndpointUrl}api/aem/product/deliverypromise/pdp/v3/${authenticationConfig.market}/${authenticationConfig.fictiveWebShop}/${productId}`,
                    method: 'GET',
                    params: {
                        mainWebshop: authenticationConfig.mainWebshop,
                        anaLang: authenticationConfig.anaLang,
                        language: authenticationConfig.locale,
                        skuId,
                    },
                };
                axiosClient.request(axiosConfig).then(response => {
                    if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data.deliveryPromises)) {
                        resolve(response.data);
                    }
                    reject();
                }, reject);
            });
        };
        this.getDeliveryPromiseExtended = (servicesEndpointUrl, authenticationConfig, productId, skuId, selectedStoreId) => __awaiter(this, void 0, void 0, function* () {
            let url = `${servicesEndpointUrl}api/aem/product/deliverypromise/pdp/extended/${authenticationConfig.market}/${authenticationConfig.mainWebshop}/${productId}`;
            if (skuId) {
                url += `/${authenticationConfig.locale}/${skuId}`;
                if (selectedStoreId) {
                    url += `/${selectedStoreId}`;
                }
            }
            const result = yield axiosClient.get(url);
            return result.data;
        });
        this.getBulkDeliveryPromise = (data_1, apiEndpoint_1, _a) => __awaiter(this, [data_1, apiEndpoint_1, _a], void 0, function* (data, apiEndpoint, { market, fictiveWebShop, mainWebshop, anaLang }) {
            const axiosConfig = {
                data,
                params: {
                    mainWebshop,
                    language: anaLang,
                },
                method: 'POST',
                url: `${apiEndpoint}api/aem/product/deliverypromise/pdp/bulk/v3/${market}/${fictiveWebShop}`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getBundleDeliveryPromise = (apiEndpoint, defaultRequestParams, businessUnitId, products) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                data: {
                    products,
                    businessUnitId,
                    market: defaultRequestParams.market,
                    mainWebShopId: defaultRequestParams.shopId,
                    fictiveShopId: defaultRequestParams.shopId,
                    language: defaultRequestParams.language,
                    type: 'WEB',
                },
                method: 'POST',
                url: `${apiEndpoint}api/deliverypromise/basket`,
                withCredentials: true,
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new DeliveryPromiseAPI();
